import React from "react";
import Sidebar from "../../components/commons/Sidebar";
import BlogTable from "../../components/admin/blog/blog";

const BlogsAdminPage = () => {
  return (
    <div className="flex flex-col md:flex-row min-h-screen bg-slate-50">
      <Sidebar />
      <BlogTable />
    </div>
  );
};

export default BlogsAdminPage;
